import React from 'react';
import withDrilldown from '../withDrilldown';
import Drilldown from './Drilldown';

const InputWithDrillDown = withDrilldown(Drilldown, { field: '', text: '' });

export default function AddressInput(props) {
	return <InputWithDrillDown {...props} />;
}
